
import { apiFetch } from "./api";

export function addChart(machineId, kategorieId) {
  return apiFetch(`/dashboard/${machineId}/charts/add`, {
    method: "POST",
    body: JSON.stringify({ kategorieId }),
  });
}